<template>
  <nav class="footer__company column">
    <h4>{{ t('footer_06') }}</h4>

    <router-link :to="`/${$store.state.language}/legal`">
      <span>{{ t('footer_07') }}</span>
    </router-link>

    <router-link :to="`/${$store.state.language}/privacy`">
      <span>{{ t('footer_08') }}</span>
    </router-link>

    <router-link :to="`/${$store.state.language}/terms`">
      <span>{{ t('footer_09') }}</span>
    </router-link>
  </nav>
</template>

<style lang="scss" scoped>
@import '../styles.scss';
</style>
